import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import ShiftLogLayer from '../components/ShiftLogLayer';

const ShiftLogsPage = () => {
  return (
    <MasterLayout pageTitle="Shift Logs">
      <ShiftLogLayer />
    </MasterLayout>
  );
};

export default ShiftLogsPage;
